var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tr',[_c('b-td',{staticClass:"text-center",attrs:{"colspan":_vm.cs}},[_c('b-spinner',{attrs:{"small":""}}),_c('span',{staticClass:"spinner-label"},[_vm._v("Loading...")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }